import React from 'react'
import { css } from 'styled-components'
import { IoIosArrowBack } from 'react-icons/io'
import { colors, palette, space, fontSizes, mediaQueries, breakpoints } from '../../../utils/tokens'
import { navigate } from 'gatsby'
import FormSubmitButton from './FormSubmitButton'

const FormNavigation = ({
  onSubmit,
  onBack,
  previousLink,
  customButton,
}) => {

  const handleBack = () => {
    onBack && onBack()
    navigate(previousLink)
  }

  return (
    <div
      css={css({
        width: `100%`,
        backgroundColor: colors.white,
        bottom: 0,
        left: 0,
        position: `absolute`,
      })}
    >
      <div
        css={css({
          padding: `${space[4]}px ${space[3]}px`,
          maxWidth: breakpoints.sm,
          height: `100%`,
          borderTop: `1px solid ${palette.grey[30]}`,
          display: `flex`,
          alignItems: `space-between`,
          justifyContent: `space-between`,
          [mediaQueries.xxl]: {
            padding: `${space[4]}px 0`,
            marginLeft: `${space[5]}px`,
          },
        })}
      >
        {previousLink && (
          <button
            onClick={handleBack}
            css={css({
              background: `unset`,
              border: `none`,
              display: `flex`,
              justifyContent: `center`,
              cursor: `pointer`,
              fontSize: fontSizes[3],
              fontWeight: `normal`,
              color: palette.grey[60],
            })}
          >
            <IoIosArrowBack />
            <span>Back</span>
          </button>
        )}
        {customButton ? (
          customButton
        ) : (
          <FormSubmitButton
            onClick={onSubmit}
            label="Continue"
          />
        )}
      </div>
    </div>
  )
}

export default FormNavigation